import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1, 2),
    overflow: "auto",
  },
  formControl: {
    minWidth: "180px",
    margin: theme.spacing(1, 0, 0, 0),
  },
}));
